import React, { FC, useEffect, useState } from 'react'
import { Arrow } from '../../../../constants/svg'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import { renderRichText } from '../../../../utils/richTextHandler.utils'
import WrapperImage from '../../wrapperImage'
import { ButterBarStyles } from '../style'
import { CountDown } from './countdown'

type ButterBarProps = {
  headerData: any
}

export const ButterBar: FC<ButterBarProps> = ({ headerData }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    if (headerData) {
      const timeoutId = setTimeout(() => {
        setIsLoaded(true)
      }, 1000) // 1 second delay

      return () => clearTimeout(timeoutId) // Cleanup on unmount or dependency change
    }
  }, [headerData])

  return (
    <ButterBarStyles
      $backgroundUrl={headerData?.butterBar?.backgroundImage?.file?.url}
      className="butterbar-layout">
      <a
        href={
          headerData?.butterBar?.cta?.internalLink
            ? internalLinkHandler(headerData?.butterBar?.cta?.internalLink)
            : headerData?.butterBar?.cta?.externalUrl || 'https://www.uipath.com/'
        }
        className="butterBar__link butterbar-countdown"
        id="butterbar-countdown"
        style={{ opacity: isLoaded ? 1 : 0 }}>
        <div className="row__firstline">
          {headerData?.butterBar?.image1?.image?.file?.url && (
            <WrapperImage
              className="firstImage"
              src={ImgUtil.getResizedImageUrl(headerData?.butterBar?.image1?.image?.file?.url, '')}
            />
          )}
          {headerData?.butterBar?.countdown?.clockIntro && (
            <p>{headerData?.butterBar?.countdown?.clockIntro}</p>
          )}
        </div>
        <div className="countDown__butterBar">
          {headerData?.butterBar?.countdown ? (
            <CountDown headerData={headerData?.butterBar?.countdown} />
          ) : (
            <span className="ticketText">
              {headerData?.butterBar?.title && renderRichText(headerData?.butterBar?.title)}
            </span>
          )}
          {headerData?.butterBar?.image2?.image?.file?.url && (
            <WrapperImage
              className="secondImage"
              src={ImgUtil.getResizedImageUrl(headerData?.butterBar?.image2?.image?.file?.url, '')}
            />
          )}
        </div>
        {headerData?.butterBar?.cta?.text && (
          <span className="cta__link">
            <span>{headerData?.butterBar?.cta?.text}</span>
            <Arrow />
          </span>
        )}
      </a>
    </ButterBarStyles>
  )
}
